const performanceStats = [
  {
    label: 'CADR',
    stats: {
      BB: {
        value: '447',
        isBold: true,
      },
      BS: {
        value: '416',
        isBold: true,
      },
      CC: {
        value: '350',
        isBold: false,
      },
      RP: {
        value: '364',
        isBold: true,
      },
      HW: {
        value: '300',
        isBold: false,
      },
      MB: {
        value: '245',
        isBold: false,
      },
      OR: {
        value: '254',
        isBold: false,
      },
    },
  },
  {
    label: 'TVOC REMOVAL rate',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '75.56%',
        isBold: true,
      },
      RP: {
        value: '74.85%',
        isBold: false,
      },
      HW: {
        value: '92.81%',
        isBold: true,
      },
      MB: {
        value: '92.48%',
        isBold: true,
      },
      OR: {
        value: '97.89%',
        isBold: true,
      },
    },
  },
  {
    label: 'FORMALDEHYDE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '34.00%',
        isBold: false,
      },
      RP: {
        value: '45.40%',
        isBold: false,
      },
      HW: {
        value: '95.60%',
        isBold: true,
      },
      MB: {
        value: '48.8%*',
        isBold: false,
      },
      OR: {
        value: '96.60%',
        isBold: true,
      },
    },
  },
  {
    label: 'AMMONIA',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '75.60%',
        isBold: false,
      },
      RP: {
        value: '21.52%*',
        isBold: false,
      },
      HW: {
        value: '31.20%*',
        isBold: false,
      },
      MB: {
        value: '4.80%',
        isBold: false,
      },
      OR: {
        value: '17.20%',
        isBold: false,
      },
    },
  },
  {
    label: 'BENZENE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '75.00%',
        isBold: false,
      },
      RP: {
        value: '78.57%',
        isBold: false,
      },
      HW: {
        value: '91.02%',
        isBold: true,
      },
      MB: {
        value: '92.98%',
        isBold: false,
      },
      OR: {
        value: '96.94%',
        isBold: true,
      },
    },
  },
  {
    label: 'TOLUENE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '77.33%',
        isBold: true,
      },
      RP: {
        value: '76.39%',
        isBold: false,
      },
      HW: {
        value: '94.86%',
        isBold: true,
      },
      MB: {
        value: '94.80%',
        isBold: true,
      },
      OR: {
        value: '98.99%',
        isBold: true,
      },
    },
  },
  {
    label: 'BUTYL ACETATE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '76.40%',
        isBold: true,
      },
      RP: {
        value: '75.58%',
        isBold: false,
      },
      HW: {
        value: '93.79%',
        isBold: true,
      },
      MB: {
        value: '93.33%',
        isBold: true,
      },
      OR: {
        value: '98.49%',
        isBold: true,
      },
    },
  },
  {
    label: 'N-UNDECANE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '76.92%',
        isBold: true,
      },
      RP: {
        value: '75.34%',
        isBold: false,
      },
      HW: {
        value: '93.33%',
        isBold: true,
      },
      MB: {
        value: '92.47%',
        isBold: true,
      },
      OR: {
        value: '98.06%',
        isBold: true,
      },
    },
  },
  {
    label: 'ETHYLBENZENE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '75.61%',
        isBold: true,
      },
      RP: {
        value: '74.68%',
        isBold: false,
      },
      HW: {
        value: '92.96%',
        isBold: true,
      },
      MB: {
        value: '92.20%',
        isBold: true,
      },
      OR: {
        value: '98.00%',
        isBold: true,
      },
    },
  },
  {
    label: 'P-XYLENEOU',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '76.00%',
        isBold: true,
      },
      RP: {
        value: '73.97%',
        isBold: false,
      },
      HW: {
        value: '93.47%',
        isBold: true,
      },
      MB: {
        value: '92.76%',
        isBold: true,
      },
      OR: {
        value: '98.24%',
        isBold: true,
      },
    },
  },
  {
    label: 'M-XYLENE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '75.31%',
        isBold: true,
      },
      RP: {
        value: '74.68%',
        isBold: false,
      },
      HW: {
        value: '93.25%',
        isBold: true,
      },
      MB: {
        value: '92.56%',
        isBold: true,
      },
      OR: {
        value: '98.13%',
        isBold: true,
      },
    },
  },
  {
    label: 'O-XYLENE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '73.61%',
        isBold: true,
      },
      RP: {
        value: '74.30%',
        isBold: false,
      },
      HW: {
        value: '92.60%',
        isBold: true,
      },
      MB: {
        value: '91.95%',
        isBold: true,
      },
      OR: {
        value: '97.89%',
        isBold: true,
      },
    },
  },
  {
    label: 'STYRENE',
    stats: {
      BB: {
        value: 'N/A',
        isBold: false,
      },
      BS: {
        value: 'N/A',
        isBold: false,
      },
      CC: {
        value: '71.43%',
        isBold: true,
      },
      RP: {
        value: '70.00%',
        isBold: false,
      },
      HW: {
        value: '88.52%',
        isBold: true,
      },
      MB: {
        value: '89.03%',
        isBold: true,
      },
      OR: {
        value: '96.10%',
        isBold: true,
      },
    },
  },
];
export default performanceStats;
